import IWillPlan from 'components/IWillPlan';
import React, { useState } from 'react';
import { IGetStarted } from '../types/get-started.type';
import { selectPlan } from 'utils';
import { useGetPlans } from 'common/queries-and-mutations/payment';

type Props = {
  onSubmit: (planId: number, planAmount: number) => void;
  formValue: IGetStarted;
};

export default function Plan({ onSubmit }: Props) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedPlan, setSelectedPlan] = useState<number | null>(null);
  const { data: plans } = useGetPlans();

  return (
    <div className="mx-20 my-44">
      <p className="text-center text-3xl font-medium text-[#353535]">
        Select A Plan
      </p>
      <div
        className="mx-10 flex w-full items-center justify-center gap-5 overflow-x-auto p-10 scrollbar-hide"
        style={{ scrollbarWidth: 'none' }}
      >
        {(plans ?? []).map((plan, index) => (
          <div
            role="button"
            tabIndex={-1}
            // onKeyDown={() => onSubmit(plan.planId, plan.price)}
            // onClick={() => onSubmit(plan.planId, plan.price)}
            key={plan.planId}
          >
            <IWillPlan
              iWillLogo={plan.image}
              iWillPrice={plan.price}
              iWillPackages={plan.packages}
              iWillPlanId={plan.planId}
              isUseLink={false}
              onSubmit={() => onSubmit(plan.planId, plan.price)}
              // isRecommended={!!plan.isRecommended}
              isRecommended={index === 2}
              onPlanSelect={() => {
                setSelectedPlan(plan.planId);
                selectPlan(plan.planId, plans ?? []);
              }}
              isSelectedPlan={!!plan.isSelectedPlan}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
